import type { IconWrapperProps } from '@/core/components/icon/icon-wrapper';
import type { SVGIconProps } from '@/core/components/icon/svg-icon';

import { IconWrapper } from '@/core/components/icon/icon-wrapper';
import SVGIcon from '@/core/components/icon/svg-icon';

export default function EmailIcon(props: SVGIconProps & IconWrapperProps) {
    return (
        <IconWrapper {...props}>
            <SVGIcon
                {...props}
                viewBox={'0 0 18 14'}
            >
                <path
                    d={
                        'M0 0v14h18V0zm8.981 8.484L1.391.826h15.392zM5.727 6.412l-4.994 5.95V1.358zm.646.574 2.608 2.66 2.646-2.618 5.044 5.964H1.28zm5.764-.49 4.981-4.872v10.794z'
                    }
                />
            </SVGIcon>
        </IconWrapper>
    );
}

export { EmailIcon };
